import React from 'react';
import { CircularProgress, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton } from '@mui/material';
import { useSelector } from 'react-redux';
import CloseIcon from '@mui/icons-material/Close';
import MDButton from 'components/MDButton';

export default function ConfirmationModal({ closeModal }) {
  const { modalData, isLoading = false } = useSelector(state => state.modal);
  const { handleSubmit, title, description, submitBtnLabel, submitBtnColor = 'error' } = modalData;

  return (
    <>
      <DialogTitle id='draggable-dialog-title' display='flex' alignItems='center' justifyContent='space-between'>
        {title}
        <IconButton onClick={closeModal} edge='end' size='small'>
          <CloseIcon fontSize='medium' />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          {description}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <MDButton onClick={closeModal} size='small' color='secondary'>
          Cancel
        </MDButton>
        <MDButton onClick={() => handleSubmit(modalData)} size='small' color={submitBtnColor}>
          {isLoading ? <CircularProgress size={16} color='light' /> : submitBtnLabel}
        </MDButton>
      </DialogActions>
    </>
  );
}